import React, { ReactNode } from "react";

interface CollapsibleSectionProps {
    title: string;
    children: ReactNode;
    defaultOpen?: boolean;
}

interface CollapsibleSectionState {
    isOpen: boolean;
}

export class CollapsibleSection extends React.Component<CollapsibleSectionProps, CollapsibleSectionState> {
    constructor(props: CollapsibleSectionProps) {
        super(props);
        this.state = {
            isOpen: props.defaultOpen || false
        };
    }

    toggleSection = () => {
        this.setState(prevState => ({
            isOpen: !prevState.isOpen
        }));
    }

    render() {
        return (
            <div className="collapsibleSection">
                <button 
                    className="collapsibleHeader"
                    onClick={this.toggleSection}>

                    {this.state.isOpen ? 
                        <span className="buttonIcon">▼</span> : // change for more website consistent icons?
                        <span className="buttonIcon">▶</span>
                    }
                    <span>{this.props.title}</span>
                </button>
                {this.state.isOpen && (
                    <div className="collapsibleContent">
                        <div className="gridContainer">
                            {this.props.children}
                        </div>
                    </div>
                )}
            </div>
        );
    }
}